import { useAuthentication } from '@givebacks/api';
import { Button } from 'ui';

import { UnsubscribeFromCauseButton } from './UnsubscribeModal';

const CauseStatusButton = ({
  status,
  causeId,
  token,
  fullWidth = false,
  onUnsubscribe,
  isLoading,
  onSubscribe,
}: {
  status?: string;
  causeId?: string;
  token?: string;
  fullWidth?: boolean;
  onUnsubscribe?: () => void;
  isLoading?: boolean;
  onSubscribe?: () => void;
}) => {
  const { isAuthenticated } = useAuthentication();

  if (status === 'subscribed') {
    return (
      <UnsubscribeFromCauseButton
        causeId={causeId}
        token={token}
        fullWidth={fullWidth}
        onUnsubscribe={onUnsubscribe}
      />
    );
  }

  if (isAuthenticated) {
    return (
      <Button
        size={fullWidth ? 'md' : 'sm'}
        fullWidth={fullWidth}
        onClick={onSubscribe}
        loading={isLoading}
      >
        Opt-In to Communications
      </Button>
    );
  }

  return null;
};

export { CauseStatusButton };
